import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFlow} from "../../../../../data/interfaces/iflow.interface";
import {faCircleExclamation, faCircleInfo, faRotateRight, faUserCheck} from "@fortawesome/free-solid-svg-icons";
import {ESTADOS_LX} from "../../../../../shared/ui/liga-ui";

// Paso que revisa nuestro equipo (MANUAL): solo explica qué pasa y regresa a la
// lista con onEndProcess(true), como siempre. Estilos en _liga-ui.scss y _liga-b.scss.
@Component({
  selector: 'app-manual-validation-component',
  templateUrl: './manual-validation-component.component.html',
  styleUrls: ['./manual-validation-component.component.scss']
})
export class ManualValidationComponentComponent implements OnInit {
  @Input() data!: IFlow
  @Output() onEndProcess = new EventEmitter()
  settings = {description: '', img: ''}

  readonly estados = ESTADOS_LX
  readonly iconos = {
    equipo: faUserCheck,
    reintentar: faRotateRight,
    error: faCircleExclamation,
    ayuda: faCircleInfo
  }
  titulo = ''
  subtitulo = ''
  // La imagen de la configuración no cargó: se quita en vez de dejar un hueco.
  imagenFallo = false

  constructor() {}

  ngOnInit() {
    try {
      this.settings = {...this.settings, ...JSON.parse(this.data.properties.settings)}
    } catch {
      // Sin configuración legible queda el texto general del paso.
    }
    this.titulo = this.data?.properties?.title || 'Validación de tu información'
    this.subtitulo = this.data?.properties?.subtitle || 'Nuestro equipo revisa este paso por ti.'
  }

  entendido() {
    this.onEndProcess.emit(true)
  }
}
